import {__VersionedSettingsState__v0} from '@/features/settings/store/migrations/20250301-initial-migration';

const migration = new Date('2025-03-02').getTime();

type __VersionedSettingsState__v1 = {
  theme: {
    name: 'light' | 'dark' | 'system';
  };
  ui: {
    sidebarIsOpen: boolean;
  };
};

function migration_20250302_add_theme(
  state: unknown,
  version: number,
): __VersionedSettingsState__v1 {
  if (version < migration) {
    return {
      ...(state as __VersionedSettingsState__v0),
      theme: {
        name: 'system',
      },
    };
  }

  return state as __VersionedSettingsState__v1;
}

export {migration_20250302_add_theme};
